import { useTranslation } from 'react-i18next';
import { useFormState } from 'react-final-form';
import { FilterLocations } from '../../../common/FilterLocations';
import { FiltersSection } from '../FiltersSection';
import {
  FilterLocationsWrapper,
  MainFiltersContainer,
  mainSectionStyles
} from './styled';
import useScreenSize from '../../../../../hooks/useScreenSize';
import { NewSearchLeasedFilters } from '../NewSearchLeasedFilters';
import { ModalParams } from '../../../NewSearchBar/types';

interface MainFiltersProps {
  modalParams: ModalParams;
  toggleHandlerLocations: () => Promise<void>;
}

export const MainFilters = ({
  modalParams,
  toggleHandlerLocations
}: MainFiltersProps) => {
  const { t } = useTranslation();
  const { isSmall } = useScreenSize();
  const renderProps = useFormState();
  const screen = modalParams?.initialScreen;

  return (
    <MainFiltersContainer>
      <FiltersSection
        title={isSmall ? '' : t('search.locations_search.title')}
        styles={mainSectionStyles}
      >
        <FilterLocationsWrapper>
          <FilterLocations
            handleOpenLocations={toggleHandlerLocations}
            modalScreen={screen}
          />
        </FilterLocationsWrapper>
      </FiltersSection>
      <FiltersSection
        title={isSmall ? '' : t('search.filters.dealType')}
        styles={mainSectionStyles}
      >
        <NewSearchLeasedFilters value={renderProps.values?.leased} />
      </FiltersSection>
    </MainFiltersContainer>
  );
};
